import { Environments, PartialServiceMap } from '@innovyze/stylovyze';

const config: PartialServiceMap = {
	// Sample config for overwritting service endpoints
	[Environments.LOCAL]: {
		assets: 'https://saas-asset-management.info360-dev.com/dev',
		amInspection: 'https://saas-inspection-management.info360-dev.com/dev',
		amRisk: 'https://saas-risk-management.info360-dev.com/dev',
		amUpload: 'https://saas-upload-service.info360-dev.com/dev',
	},
	[Environments.DEV]: {
		assets: 'https://saas-asset-management.info360-dev.com/dev',
		amInspection: 'https://saas-inspection-management.info360-dev.com/dev',
		amRisk: 'https://saas-risk-management.info360-dev.com/dev',
		amUpload: 'https://saas-upload-service.info360-dev.com/dev',
	},
};

export default config;
